import type React from 'react';

import { Button, Image, Text } from '@change/ds-core-ui';
import { OpenInNewIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import gmailIcon from '#src/app/pages/loginOrSignup/shared/assets/gmail.svg';

import { useNoPasswordStep } from './hooks/useNoPasswordStep';

export const NoPasswordStep: React.FC<EmptyProps> = () => {
	const {
		data: { isGmail },
		actions: { trackOpenInGmailClick },
	} = useNoPasswordStep();

	if (!isGmail) return null;

	return (
		<div>
			<Button
				className="w-full"
				variant="secondary"
				as="a"
				onClick={trackOpenInGmailClick}
				size="large"
				target="_blank"
				href="https://mail.google.com/mail/u/0/#search/from%3A(%40a.change.org)+in%3Aanywhere"
				data-qa="no-password-step-open-gmail"
				data-testid="no-password-step-open-gmail"
			>
				<div className="flex items-center">
					<Image className="h-5 w-5" aria-hidden="true" src={gmailIcon} />
					<Text fontWeight="bold" className="mx-2" as="span" size="large">
						<Translate value="corgi.login_or_signup.forgot_password.open_gmail_button" />
					</Text>
					<OpenInNewIcon size="small" />
				</div>
			</Button>
		</div>
	);
};
